export var appCustomCssRelativePath = "/snippets/css";
export var createAppCustomCssApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + appCustomCssRelativePath;
    return {
        get: function () { return http.get("" + apiUrl); },
        update: function (dto) { return http.put("" + apiUrl, dto.data); }
    };
};
//# sourceMappingURL=index.js.map